<div class="closed-month">
    {{
        'SHOP.SHARED.EVENTS.DAY_OUT_OF_LIMITS'
            | translate
                : {
                      monthStatus:
                          ((selectedMonth.status === monthlyEventsStatusEnum.CLOSED
                              ? 'SHOP.SHARED.EVENTS.CLOSED'
                              : selectedMonth.status === monthlyEventsStatusEnum.OPEN
                              ? 'SHOP.SHARED.EVENTS.ACTIVE'
                              : 'SHOP.SHARED.EVENTS.INACTIVE'
                          ) | translate)
                  }
    }}
</div>

<div *ngIf="eventsToDeactivate.length > 0" class="closed-month">
    {{ 'SHOP.SHARED.EVENTS.REFUND_DISCLAIMER' | translate }}
</div>

<div class="text-box" *ngIf="eventsToDeactivate.length > 0">
    <h4>{{ 'SHOP.SHARED.EVENTS.DAYS_TO_DEACTIVATE' | translate }}</h4>
    <p class="text" *ngFor="let event of eventsToDeactivate | sortByDateString: '':'asc'">{{ event }}</p>
</div>

<div class="text-box" *ngIf="eventsToActivate.length > 0">
    <h4>{{ 'SHOP.SHARED.EVENTS.DAYS_TO_ACTIVATE' | translate }}</h4>
    <p class="text" *ngFor="let event of eventsToActivate | sortByDateString: '':'asc'">{{ event }}</p>
</div>
